/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/
import { useState, useEffect } from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import Select from 'react-select';
import AssetService from '../../services/asset.service';
import { toast } from 'react-hot-toast';

const SearchCustomer = ({customers, customerName, onCustomerSearch, setCustomerList, searchType, setSearchType, emailLoaded, addressLoaded}) => {

    const [inputValue, setInputValue] = useState('');
    const [autocompletedItems, setAutocompletedItems] = useState([]);
    const [deviceResults, setDeviceResults] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [timeout, setTimeoutState] = useState(null);
    const [isLoading, setIsLoading] = useState(false);


    const onSearchTypeChange = async (e) => {
        var str = e.target.value;

        if (str === "email" || str === "address") {
            //setCustomerList(str);
        }

        //todo create a callback for loading effecting the search bar ? (set a bool to change the disabled & placeholder text below)

        setSearchType(str);
    }

    const onFocus = () => {

    }

    const handleOnSearch = async (string, results) => {
        setInputValue(string);
        if (results !== undefined && results.length > 0) 
        {
            setAutocompletedItems(results);
        }
        return;
    };

    const handleOnSelect = async (selectedItem) => {
        try {
            if (searchType !== 'mac') {
                setInputValue("");
                setAutocompletedItems([]);
                if (selectedItem !== undefined) {
                    onCustomerSearch(selectedItem);
                }
                return;
            }
            else {
                setSelectedOption(selectedItem);

                const promise = AssetService.getassetindex(selectedItem.value, false);

                toast.promise(promise, {
                    loading: 'Searching Customers...',
                    error: (err)=> err.message || 'Error Finding Customer'
                });

                try {
                    const response = await promise;
                    if (response === undefined || response.data === undefined) {
                        toast.error("Error Finding Customer");
                        return;
                    }
                    const assetDetails = response.data.assetObject;
                    const customerId = assetDetails.organizationId.toString();
                    const matchedCustomer = customers.find(c => c.organizationId === customerId);
                    if (matchedCustomer) {
                        let customerSelected = 
                            { 
                                id: matchedCustomer.organizationId, 
                                name: matchedCustomer.name, 
                                phone: matchedCustomer.phone, 
                                organizationId: matchedCustomer.organizationId 
                            };
                            

                        if (customerSelected !== undefined) {
                            onCustomerSearch(customerSelected);
                        }
                    }
                    else {
                        toast.error("This Asset Does Not Exist In This Partner", "error");
                    }
                }catch(error) {
                    console.log(error);
                }finally {
                    setInputValue("");
                    setAutocompletedItems([]);
                    setSelectedOption(null);
                } 
            }
        } catch (error) {
            console.error('Error fetching asset details or matching customer:', error);
        }
    };

    const handleInputChange = (newInputValue) => {
        setIsLoading(true);
        if (newInputValue.length === 0) {
            setAutocompletedItems([]);
            setDeviceResults([]);
            setIsLoading(false);
            setSelectedOption(null);
            setOptions([]);
            return;
        }
        else if (newInputValue.length >= 3) {
            if (timeout) {
                clearTimeout(timeout);
            }

            const timeoutTrigger = setTimeout(async () => {
                try {
                    const response = await AssetService.omniSearch(newInputValue);

                    if (response && response.listCurriedResults.length > 0) {
                        const filteredResults = response.listCurriedResults.filter(r =>
                            r.name &&
                            r.name.trim().length === 16 &&
                            !/home|hvac/i.test(r.name)
                        );

                        const results = filteredResults.map((device) => ({
                            label: device.name,
                            value: device.id,
                        }));
                        setOptions(results);
                        setIsLoading(false);
                    } else {
                        setOptions([]);
                        setIsLoading(false);
                    }
                } catch (error) {
                    console.error('Search failed:', error);
                    setOptions([]);
                    setIsLoading(false);
                }
                }, 500);

            setTimeout(timeoutTrigger);
        }
    };

    useEffect(() => {
        document.querySelector(".search-container input").value = "";
    }, []);

        let customersRemapped = customers.map(customer => ({ id: customer.organizationId, name: customer.name, phone: customer.phone, organizationId: customer.organizationId }));
        let searchComponent = searchType === 'mac' ?
        <Select
          defaultInputValue={inputValue}   
          value={selectedOption}
          onInputChange={handleInputChange}  
          options={options}
          isLoading={isLoading}
          placeholder="Search Mac IDs"
          onChange={handleOnSelect}
          noOptionsMessage={() => "No results"}
          isClearable
        /> :
            <ReactSearchAutocomplete
                items={searchType === 'mac' ? deviceResults : customersRemapped}
                onSelect={handleOnSelect}
                onFocus={onFocus}
                onSearch={handleOnSearch}
                inputSearchString={inputValue}
                placeholder={searchType === 'mac' ? "Search Mac IDs" : "Search Customers"}
                styling={{
                    height: '38px',
                    borderRadius: '.3em'
                }}
                loading={isLoading}
            />;

        return (
            <div className="sidebar-search-container search-container">
                <span className="sidebar-select-message search-message">
                    <select className="sidebar-search-select" value={searchType} onChange={onSearchTypeChange}>
                        <option key="1" id="1" value="name">Search Name &nbsp;</option>
                        <option key="2" id="2" value="phone">Search Phone # &nbsp;</option>
                        <option key="3" id="3" value="mac">Search MAC &nbsp;</option>
                    </select>
                </span>
                <div>
                    <span>
                        <span>
                            {searchComponent}
                        </span>
                    </span>
                </div>
            </div>
        );
}

SearchCustomer.defaultProps= {
        customers: [],
        customerName: null,
        onCustomerSearch: null,
        setCustomerList: [],
        searchType: null,
        setSearchType: null,
        emailLoaded: false,
        addressLoaded: false
};
export default SearchCustomer;